export enum UploadStatus {
  UPLOADING = 'UPLOADING',
  REJECTED = 'REJECTED',
  QUEUED = 'QUEUED',
}

export enum UploadRejectionCode {
  UNKNOWN = 'unknown',
  FILE_TOO_LARGE = 'file-too-large',
}
